// Third-party Imports
import classnames from 'classnames'

// Type Imports
import type { ChildrenType, SystemMode } from '@core/types'

// Hook Imports
import { useSettings } from '@core/hooks/useSettings'
import useLayoutInit from '@core/hooks/useLayoutInit'

// Util Imports
import { blankLayoutClasses } from './utils/layoutClasses'
import { GlobalStyles, Typography } from '@mui/material'
import Link from '@/components/Link'
type Props = ChildrenType & {
  systemMode: SystemMode
}

const AuthLayout = (props: Props) => {
  const { __ } = useTranslator()
  // Props
  const { children, systemMode } = props

  // Hooks
  const { settings } = useSettings()

  useLayoutInit(systemMode)

  return (
    <>
      <GlobalStyles
        styles={{
          'input:-webkit-autofill, input:-webkit-autofill:focus, input:-webkit-autofill:hover, input:-webkit-autofill:active,input[type="password"]:-webkit-autofill, input[type="password"]:-webkit-autofill:focus, input[type="password"]:-webkit-autofill:hover, input[type="password"]:-webkit-autofill:active':
            {
              WebkitBoxShadow: '0 0 0 1000px #fff inset',
              boxShadow: '0 0 0 1000px #fff inset',
              WebkitTextFillColor: '#2F2B3DE5',
              caretColor: '#2F2B3DE5',
              transition: 'background-color 5000s ease-in-out 0s',
              padding: '5px 15px !important',
              margin: '0 !important',
              borderRadius: '50px !important'
            }
        }}
      />

      <div className={classnames(blankLayoutClasses.root, 'is-full bs-full')} data-skin={settings.skin}>
        <div className='flex items-center md:justify-evenly justify-end background md:px-10 h-full min-bs-[100dvh] '>
          <div className='flex justify-center items-center bs-full !min-is-full md:!min-is-[unset] h-full'>
            <div className='flex flex-col gap-6 is-full sm:is-auto md:is-full sm:max-is-[400px] md:max-is-[unset] mbs-11 mbe-11 sm:mbs-14 md:mbs-0 md:mbe-0 bs-full md:min-bs-[90dvh] min-bs-[80dvh]'>
              <img src='/images/pages/content.png' alt='' width={60} height={60} className='mt-[50px]' />
              <div className='flex flex-col mt-auto'>
                <div className='flex gap-2'>
                  <img src='/images/pages/lift-logo-w.png' alt='' width={98} height={46} />
                  <span className='text-[45px] text-[#ffffff]'>{__('Partner Portal')}</span>
                </div>
                <Typography variant='h5' className='text-white mt-2 text-[64px]'>
                  {__('Hey, Hello!')}
                </Typography>
                <Typography variant='subtitle1' className='text-white text-[15px]'>
                  {__('Access your dashboard and manage with ease.')}
                </Typography>
                <Typography variant='subtitle1' className='text-white text-[18px] font-500 mt-[30px]'>
                  {__('They need early pay, we make it happen seamlessly,')} <br></br>
                  {__('securely, and right on time.')}
                </Typography>
              </div>
              <div className='mt-auto'>
                <Link href='/' className='text-white text-[15px]'>
                  {__('License')}
                </Link>
                <Link href='/' className='text-white text-[15px] ml-4'>
                  {__('Support')}
                </Link>
              </div>
            </div>
          </div>

          <div className='flex justify-center items-center bs-full bg-backgroundPaper !min-is-full md:!min-is-[unset] md:p-12 md:is-[586px] h-full rounded-tr-2xl rounded-tl-2xl mt-[100px]'>
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

export default AuthLayout
